import { FC } from 'react'
import { useMediaQuery, useTheme } from '@mui/material'
import { NotificationsEmptyDetail, NotificationsList } from 'components/Notifications'
import { UserProtectedRoute } from 'routes'

// Index route of /notifications. On desktop the list lives in the layout's
// left column and the right pane shows the empty-detail placeholder.
const NotificationsPage: FC = () => {
  const theme = useTheme()
  const isDesktop = useMediaQuery(theme.breakpoints.up('md'))

  return (
    <UserProtectedRoute>
      {isDesktop ? <NotificationsEmptyDetail /> : <NotificationsList />}
    </UserProtectedRoute>
  )
}

export default NotificationsPage
